const getTargetURL = ({ targetURL, target }) => targetURL || (target?.type === 'externalLink' && target?.href);

export default getTargetURL;
